import { url, header } from "../../apis/Index";
import { toast } from "react-toastify";
import axios from "axios";

export const getSatStudyAttendees = () => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_SAT_STUDY_INFO",
      fetchingLoaders: true,
    });
    axios
      .get(`${url}/v1/saturday-event-attendees`, {
        headers: header,
      })
      .then((satStudyAttendees) => {
        dispatch({
          type: "GET_SAT_STUDY_ATTENDEES",
          satStudyAttendees,
        });
        dispatch({
          type: "GETTING_BEN_SAT_STUDY_INFO",
          fetchingLoaders: false,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GETTING_BEN_SAT_STUDY_INFO",
          fetchingLoaders: false,
        });
        dispatch({
          type: "SET_BEN_SAT_STUDY_FETCH_FAILED",
          message: "Failed to load attendees",
        });
      });
  };
};

export const addSatStudyAttendee = (attendee, closeFormAfterAdding) => {
  return (dispatch) => {
    dispatch({
      type: "SENDING_BEN_SAT_STUDY_INFO",
      loader: true,
    });
    axios
      .post(`${url}/v1/saturday-event-attendees`, attendee, {
        headers: header,
      })
      .then((satStudyAttendee) => {
        dispatch({
          type: "CREATE_SAT_STUDY_ATTENDEE",
          satStudyAttendee,
        });
        dispatch({
          type: "SENDING_BEN_SAT_STUDY_INFO",
          loader: false,
        });
        closeFormAfterAdding();
        toast.success("Attendee  recorded", {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch(() => {
        dispatch({
          type: "SENDING_BEN_SAT_STUDY_INFO",
          loader: false,
        });
        dispatch({
          type: "SET_BEN_SAT_STUDY_MESSAGE",
          message: "Failed to register attendees",
        });
      });
  };
};

export const updateSatStudyAttendee = (
  updatedSatStudyAttendee,
  id,
  closeFormAfterAdding
) => {
  return (dispatch) => {
    dispatch({
      type: "SENDING_BEN_SAT_STUDY_INFO",
      loader: true,
    });
    axios
      .put(
        `${url}/v1/saturday-event-attendees/${id}`,
        updatedSatStudyAttendee,
        {
          headers: header,
        }
      )
      .then((satStudyAttendee) => {
        dispatch({
          type: "UPDATE_SAT_STUDY_ATTENDEE",
          satStudyAttendee,
        });
        dispatch({
          type: "SENDING_BEN_SAT_STUDY_INFO",
          loader: false,
        });
        closeFormAfterAdding();
      })
      .catch((error) => {
        dispatch({
          type: "SENDING_BEN_SAT_STUDY_INFO",
          loader: false,
        });
        dispatch({
          type: "SET_BEN_SAT_STUDY_MESSAGE",
          message: "Failed to update attendee",
        });
      });
  };
};

export const deleteSatStudyAttendee = (id) => {
  return (dispatch) => {
    dispatch({
      type: "DELETING_BEN_SAT_STUDY_INFO",
      deletingAction: {
        id: id,
        deleting: true,
      },
    });
    axios
      .delete(`${url}/v1/saturday-event-attendees/${id}`, {
        headers: header,
      })
      .then(() => {
        dispatch({
          type: "DELETE_SAT_STUDY_ATTENDEE",
          id,
        });
        dispatch({
          type: "DELETING_BEN_SAT_STUDY_INFO",
          deletingAction: {
            id: null,
            deleting: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: "DELETING_BEN_SAT_STUDY_INFO",
          deletingAction: {
            id: null,
            deleting: false,
          },
        });
        toast.error("Failed to delete attendee", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
        });
      });
  };
};
